module.exports = __webpack_public_path__ + "static/header-artist-e0bfbd9580ecf37770399a65bacc9fa8.jpg";